import type { EmailTemplate } from '../useData';
import type { ComposeBodyDocument } from './types';
import { composeDocFromTemplate } from './composeDocFromTemplate';

export function templateToComposeDoc(template: EmailTemplate): ComposeBodyDocument {
  return composeDocFromTemplate(template);
}

export function templateToComposeDocFromApi(template: EmailTemplate): ComposeBodyDocument {
  return composeDocFromTemplate(template);
}
